import api from './api';

const sharingService = {
  // Create share link (authenticated)
  createShareLink: async (fileId) => {
    const response = await api.post(`/files/${fileId}/share`);
    return response.data;
  },

  // Get share link info (authenticated)
  getShareLinkInfo: async (fileId) => {
    const response = await api.get(`/files/${fileId}/share`);
    return response.data;
  },

  // Revoke share link (authenticated)
  revokeShareLink: async (fileId) => {
    const response = await api.delete(`/files/${fileId}/share`);
    return response.data;
  },

  // Get shared file info (public - no auth)
  getSharedFileInfo: async (token) => {
    // Strip filename from token if present (for backward compatibility)
    const cleanToken = token.split('/')[0];
    const response = await api.get(`/share/${cleanToken}`);
    return response.data;
  },

  // Get shared file download URL (public - no auth)
  // Optional filename parameter for SEO-friendly URLs
  getSharedFileUrl: (token, filename = null) => {
    const cleanToken = token.split('/')[0]; // Remove filename if in token
    if (filename) {
      return `${api.defaults.baseURL}/share/${cleanToken}/download/${encodeURIComponent(filename)}`;
    }
    return `${api.defaults.baseURL}/share/${cleanToken}/download`;
  },

  // ============================================
  // FOLDER SHARING
  // ============================================

  // Create folder share link (authenticated)
  createFolderShareLink: async (folderId) => {
    const response = await api.post(`/folders/${folderId}/share`);
    return response.data;
  },

  // Get folder share link info (authenticated)
  getFolderShareLinkInfo: async (folderId) => {
    const response = await api.get(`/folders/${folderId}/share`);
    return response.data;
  },

  // Revoke folder share link (authenticated)
  revokeFolderShareLink: async (folderId) => {
    const response = await api.delete(`/folders/${folderId}/share`);
    return response.data;
  },

  // Get shared folder info (public - no auth)
  getSharedFolderInfo: async (token) => {
    const response = await api.get(`/share/folder/${token}`);
    return response.data;
  },

  // Get shared folder contents (public - no auth)
  // Supports subfolder navigation via optional folderId parameter
  getSharedFolderContents: async (token, folderId = null) => {
    const url = folderId
      ? `/share/folder/${token}/contents?folderId=${folderId}`
      : `/share/folder/${token}/contents`;
    const response = await api.get(url);
    return response.data;
  },
};

export default sharingService;
